






































































































































import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import { ActivitiesService } from "@/services/api/activities.service";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { UsersService } from "@/services/api/users.service";
import { CurrentUser } from "@/models/auth/current.user";
import {
  ActivityTypeDto,
  ActivityPriorityDto,
  ActivityStatusDto,
  UserDto,
  ActivityAreaDto,
  AppGroupDto,
  MetadataConfiguration
} from "@/server/app.dtos";
import { CreateActivityCommand } from "@/server/app.commands";
import SingleFileUploaderComponent from "@/components/uploaders/SingleFileUploader.vue";
import { GetActivityAreaMetadataGroupsConfigurationDtoQuery } from "@/server/app.queries";
import { ActivitiesAreasService } from "@/services/api/activities.areas.service";

@Component({
  components: {
    SingleFileUploader: SingleFileUploaderComponent
  }
})
export default class CreateActivitySideMenuComponent extends BaseSideComponent {
  @Getter("identity") identity!: CurrentUser;
  configsService: ConfigsService = new ConfigsService();
  activitiesService: ActivitiesService = new ActivitiesService();
  activitiesAreasService: ActivitiesAreasService = new ActivitiesAreasService();
  usersService: UsersService = new UsersService();
  activityTypes: ActivityTypeDto[] = [];
  activityPriorities: ActivityPriorityDto[] = [];
  activityStatus: ActivityStatusDto[] = [];
  users: UserDto[] | null = null;
  appGroups: AppGroupDto[] | null = null;
  instance: CreateActivityCommand = new CreateActivityCommand();
  metadataConfiguration: MetadataConfiguration | null = null;
  isLoading: boolean = false;
  isValid: boolean = false;
  currentType: number = 0;
  @Watch("currentType")
  onCurrentChanged(): void {
    this.instance.idActivityType = this.currentType;
  }

  get area(): ActivityAreaDto | null {
    return this.args?.activityArea || null;
  }

  async created() {
    this.instance.idActivityArea = this.area?.idActivityArea;
    this.instance.idActivityType = this.currentType;
    this.instance.idOwner = this.identity.idUser;
    this.instance.dateStart = new Date().toISOString();
    await this.Load();
  }

  async Load() {
    let query: string = "IdLanguage=" + this.currentLanguage.idLanguage;
    if (this.area != null) {
      query += "&IdActivityArea=" + this.area.idActivityArea;
    }

    // Load ActivityStatus
    await this.configsService.Load("api/activitystatus", query).then(result => {
      this.activityStatus = result;
      if (this.activityStatus.length > 0) {
        this.instance.idActivityStatus = this.activityStatus[0].idActivityStatus;
      }
    });

    // Load App Groups
    await this.configsService.Load("api/appgroups", query).then(result => {
      this.appGroups = result;
    });

    // Load ActivityTypes
    await this.configsService.Load("api/activitytypes", query).then(result => {
      this.activityTypes = result;
      if (this.activityTypes.length > 0) {
        this.currentType = this.activityTypes[0].idActivityType || 1;
      }
    });

    // Load ActivityPriorities
    await this.configsService
      .Load(
        "api/activitypriorities",
        "IdLanguage=" + this.currentLanguage.idLanguage
      )
      .then(result => {
        this.activityPriorities = result;
        if (this.activityPriorities.length > 0) {
          this.instance.idActivityPriority = this.activityPriorities[0].idActivityPriority;
        }
      });

    // Load Users
    await this.usersService
      .GetInternalUsers(this.currentLanguage)
      .then((users: UserDto[]) => (this.users = users));
  }

  async onCreateActivity() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.activitiesService
      .Create(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/activity/${id}`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  onSelectFile(file: string): void {
    this.instance.files = [file];
  }

  candEdit(): boolean {
    return true;
  }

  async loadMetadataconfiguration() {
    const query = new GetActivityAreaMetadataGroupsConfigurationDtoQuery();
    query.idLanguage = this.currentLanguage.idLanguage;
    query.idActivityArea = this.instance.idActivityArea;
    query.visibleOnCreate = true;
    await this.activitiesAreasService
      .GetMetadataGroupsConfiguration(query)
      .then(
        (result: MetadataConfiguration) => (this.metadataConfiguration = result)
      )
      .catch(() => (this.metadataConfiguration = null));
  }
}
